import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';

export const VirtualConnectionCustomSqlQueryGql: DocumentNode = gql`
  query VirtualConnectionCustomSqlQuery($vizportalUrlId: String!) {
    virtualConnections(filter: { vizportalUrlId: $vizportalUrlId }) {
      tables {
        columns {
          remoteColumn {
            table {
              ...on CustomSQLTable {
                id
                query
                name
                isUnsupportedCustomSql
              }
            }
          }
        }
      }
    }
  }
`;
